var React = require('react');

function UseCasesIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.986 12.625V7.458a3.863 3.863 0 0 0-3.851-3.875L10 15.208v14.209h14.481a2.572 2.572 0 0 0 2.567-2.2L28.819 15.6a2.593 2.593 0 0 0-.6-2.083 2.56 2.56 0 0 0-1.967-.888zM10 29.417H6.151a2.576 2.576 0 0 1-2.568-2.584v-9.041a2.576 2.576 0 0 1 2.568-2.584H10","transform":"translate(-.613)","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2px"},"data-name":"Icon"}));
}

UseCasesIcon.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33"};

module.exports = UseCasesIcon;

UseCasesIcon.default = UseCasesIcon;
